import * as _ from 'lodash'
import * as getters from '../../../store/modules/getters'
import { mapGetters, mapState } from 'vuex';
import { Organization } from '../../../store/services/api'
import ColorPicker from '../../../components/spectrum/ColorPicker.vue'
import OrgFooter from '../layouts/Footer/Footer.vue'
import OrgHeader from '../layouts/Header/Header.vue'
import AltUploadDropzone from '../../../components/asset-manager/alt-upload-dropzone/AltUploadDropZoneIndex.vue'
import FontSelector from '../../../components/common/FontSelector.vue';
import { ImageInterface } from './d';

const organizationAPI = new Organization()

export default {
  components: {
    OrgHeader,
    OrgFooter,
    AltUploadDropzone,
    FontSelector,
    ColorPicker
  },
  props: {},
  data() {
    return {
      loading: false,
      brand: {},
      activeColor: 0,
      activeFont: 0,
      activeLogo: 0,
      demoImageSrc: '',
      showUploadModal: false,
      showColor: false,
      showFont: false,
      selectedFont: '',
      selectedImage: '',
      selectedColor : '',
      breadcrumbMenus: [
        {
          id: 'organization-details',
          title: 'Organization details',
          completed: false,
          disabled: false,
          action: this.organizationToggle,
        },
        {
          id: 'brand-profile',
          title: 'Set up your brand profile',
          completed: false,
          disabled: false,
          action: this.profileToggle,
        },
        {
          id: 'editor-tour',
          title: 'Editor Tour',
          completed: false,
          disabled: false,
          action: this.editorToggle,
        },
      ],
      activeMenu: 'brand-profile'
    }
  },
  async created() {
    try {
      this.loading = true
      const data = await organizationAPI.fetchBrand()
      const brandData = data.data
      this.brand = { ...brandData }
      this.demoImageSrc = this.brand.logos[0].formats[0].src
      this.loading = false
    } catch (err) {
      this.loading = false
      this.$message.error('Error occured while fetching brand.');
    }
  },
  methods: {
    onSelectColor(idx) {
      this.activeColor = idx
    },

    onSelectLogo(logo, idx) {
      this.activeLogo = idx
      this.demoImageSrc = logo.formats[0].src
    },

    onSelectFont(idx) {
      this.activeFont = idx
    },

    onShowUploadModal() {
      this.showUploadModal = !this.showUploadModal
    },

    onShowFont() {
      this.showFont = !this.showFont
    },

    showColorPicker() {
      this.showColor = !this.showColor
    },

    onCloseUploadModal() {
      this.showModal = false
    },

    async onCompleteBrandConfig() {
      if (!this.globalTheme) return
      const theme = this.config.THEME
      const activeColor = this.brand.colors ?
        this.brand.colors[this.activeColor] : null
      const activeFont = this.brand.fonts ?
        this.brand.fonts[this.activeFont] : null
      const activeLogo = this.brand.logos ?
        this.brand.logos[this.activeLogo] : null

      
      const selectedConfigs = { activeColor, activeFont, activeLogo }
      if (_.some(selectedConfigs, (value) => value === null)) return

      try {
        this.loading = true
        const colorBasic = { ...this.globalTheme.Colors.BASIC, ['500']: activeColor.hex }
        const updatedBasicColors = {
          ...this.globalTheme.Colors,
          BASIC: colorBasic
        }

        const themeConfig = {
          key: 'THEME',
          table: 'organizationConfigs',
          value: {
            ...theme,
            logo: activeLogo.formats[0].src
          }
        }
        const globalThemeConfig = {
          key: 'GLOBAL_THEME',
          table: 'organizationConfigs',
          value: {
            ...this.globalTheme,
            mode: 'LIGHT',
            Colors: updatedBasicColors,
            FontFamily: { DEFAULT: activeFont.name }
          }
        }
        const updateThemeConfig =
          await organizationAPI.updateConfiguration(themeConfig)
        const updateGlobalConfig =
          await organizationAPI.updateConfiguration(globalThemeConfig)
        
        await Promise.all([updateThemeConfig, updateGlobalConfig])
        this.$router.push({ path: '/enterprise/integrate-builder' })
        this.loading = false
      } catch (err) {
        this.loading = false
        this.$message.error('Could not update configurations');
      }
      
    },

    onCompleteUpload(image: ImageInterface) {
      const selectedLogo = image.original

      if (!selectedLogo.trim()) return
      const logos = this.brand.logos || []
      const newLogoValue = {
        type: 'icon',
        theme: null,
        formats: [{
          src: selectedLogo,
        }]
      }
      const updatedLogoArr = [...logos, { ...newLogoValue }]
      const newBrand = { ...this.brand, logos: updatedLogoArr }
      this.brand = newBrand;
      this.demoImageSrc = this.brand.logos[this.activeLogo].formats[0].src
      this.showUploadModal = false;
    },

    updateFontFamily(font) {
      this.selectedFont = font
    },

    onSelectNewFont() {
      if (!this.selectedFont.trim()) return
      const fonts = this.brand.fonts || []
      const updatedFontsArr = [...fonts, { name: this.selectedFont }]
      const newBrand = { ...this.brand, fonts: updatedFontsArr }
      this.brand = newBrand;
      this.showFont = false;
      this.selectedFont = ''
    },

    onSelectNewColor() {
      const colors = this.brand.colors || []
      const newColorValue = {
        hex: this.selectedColor,
        type: 'accent',
      }
      const updatedColorArr = [...colors, { ...newColorValue }]
      const newBrand = { ...this.brand, colors: updatedColorArr }
      this.brand = newBrand;
      this.showColor = false; 
    },

    organizationToggle() {
      this.$router.push({
        path: 'information',
      })
    },

    profileToggle() {
      this.$router.push({
        path: 'brand-config',
      })
    },

    editorToggle() {
      this.$router.push({
        path: 'editor',
      })
    },

    onBreadCrumbSelectionChange(eventData) {
      if (eventData && eventData.action) {
        eventData.action()
        this.currentMenuId = eventData.id
      }
    },

    updateCurrentColor(color) {
      this.selectedColor = color
    }
  },
  computed: {
    ...mapGetters({
      config: getters.AUTH_GET_USER_CONFIG
    }),
    ...mapState('globalTheme', {
      globalTheme: ({ globalTheme }) => globalTheme.OrgName !== undefined ? globalTheme : null
    }),
    
    brandName() {
      return this.brand.name || 'Untiltled'
    },

    brandLogoSrc() {
      return this.brand.logos ? this.brand.logos[0].formats[0].src : ''
    },

    brandColors() {
      return this.brand.colors
    },

    brandAccentColor() {
      return this.brand.colors ? this.brand.colors[this.activeColor].hex : '#009ae6'
    },
  }
}

